<ada-card
	#ExtensionsPropertiesCard
	id="ExtensionsPropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Extensions Properties"
		data-container-selector="ada-card-header"
		id="ExtensionsPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<!-- PreInstallationActionSequence -->
		<ng-container
			*ngIf="'PreInstallationActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization"
		>
			<ada-label
				content="Pre Installation Action Sequence"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-sensor-action-sequence
				#PreInstallActionSequenceInput
				id="PreInstallActionSequenceInput"
				[availableProperties]="availableProperties"
				[contextClassName]="editorClass.className"
				[isDisabled]="isDisabled"
				[metadataObject]="serverObject$ | async"
				[propertyName]="propertyConstructor.namespace + '.PreInstallationActionSequence'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[sequence]="currentPropertyObject?.PreInstallationActionSequence"
				(sequenceChange)="setObjectPropertyValue('PreInstallationActionSequence', $event)"
			/>
		</ng-container>
		<!-- PostInstallationActionSequence -->
		<ng-container
			*ngIf="'PostInstallationActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization"
		>
			<ada-label
				content="Post Installation Action Sequence"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-sensor-action-sequence
				#PostInstallationActionSequenceInput
				id="PostInstallationActionSequenceInput"
				[availableProperties]="availableProperties"
				[contextClassName]="editorClass.className"
				[isDisabled]="isDisabled"
				[metadataObject]="serverObject$ | async"
				[propertyName]="propertyConstructor.namespace + '.PostInstallationActionSequence'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[sequence]="currentPropertyObject?.PostInstallationActionSequence"
				(sequenceChange)="setObjectPropertyValue('PostInstallationActionSequence', $event)"
			/>
		</ng-container>
		<!-- PreRepairActionSequence -->
		<ng-container *ngIf="'PreRepairActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-label
				content="Pre Repair Action Sequence"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-sensor-action-sequence
				#PreRepairActionSequenceInput
				id="PreRepairActionSequenceInput"
				[availableProperties]="availableProperties"
				[contextClassName]="editorClass.className"
				[isDisabled]="isDisabled"
				[metadataObject]="serverObject$ | async"
				[propertyName]="propertyConstructor.namespace + '.PreRepairActionSequence'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[sequence]="currentPropertyObject?.PreRepairActionSequence"
				(sequenceChange)="setObjectPropertyValue('PreRepairActionSequence', $event)"
			/>
		</ng-container>
		<!-- PostRepairActionSequence -->
		<ng-container *ngIf="'PostRepairActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-label
				content="Post Repair Action Sequence"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-sensor-action-sequence
				#PostRepairActionSequenceInput
				id="PostRepairActionSequenceInput"
				[availableProperties]="availableProperties"
				[contextClassName]="editorClass.className"
				[isDisabled]="isDisabled"
				[metadataObject]="serverObject$ | async"
				[propertyName]="propertyConstructor.namespace + '.PostRepairActionSequence'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[sequence]="currentPropertyObject?.PostRepairActionSequence"
				(sequenceChange)="setObjectPropertyValue('PostRepairActionSequence', $event)"
			/>
		</ng-container>
		<!-- PreUninstallationActionSequence -->
		<ng-container
			*ngIf="'PreUninstallationActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization"
		>
			<ada-label
				content="Pre Uninstallation Action Sequence"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-sensor-action-sequence
				#PreUninstallationActionSequenceInput
				id="PreUninstallationActionSequenceInput"
				[availableProperties]="availableProperties"
				[contextClassName]="editorClass.className"
				[isDisabled]="isDisabled"
				[metadataObject]="serverObject$ | async"
				[propertyName]="propertyConstructor.namespace + '.PreUninstallationActionSequence'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[sequence]="currentPropertyObject?.PreUninstallationActionSequence"
				(sequenceChange)="setObjectPropertyValue('PreUninstallationActionSequence', $event)"
			/>
		</ng-container>
		<!-- PostUninstallationActionSequence -->
		<ng-container
			*ngIf="'PostUninstallationActionSequence' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization"
		>
			<ada-label
				content="Post Uninstallation Action Sequence"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-sensor-action-sequence
				#PostUninstallationActionSequenceInput
				id="PostUninstallationActionSequenceInput"
				[availableProperties]="availableProperties"
				[contextClassName]="editorClass.className"
				[isDisabled]="isDisabled"
				[metadataObject]="serverObject$ | async"
				[propertyName]="propertyConstructor.namespace + '.PostUninstallationActionSequence'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[sequence]="currentPropertyObject?.PostUninstallationActionSequence"
				(sequenceChange)="setObjectPropertyValue('PostUninstallationActionSequence', $event)"
			/>
		</ng-container>
	</ada-container>
</ada-card>
